import { createReducer } from 'service/utility';

import { REMOVE_USUARIO, SET_USUARIO } from '../actions/appActions';


const initialState = null;

export default createReducer(initialState, {
  [SET_USUARIO]: (state, { usuario }) => usuario,
  [REMOVE_USUARIO]: (state) => initialState,
});
